import React, { useEffect, useState } from "react";
import { Constants } from "@eagerdog/constants";
import { RatRaceScoreDto } from "@eagerdog/interfaces";

import Input from "src/components/Input/Input";
import Dropdown, { IOption } from "src/components/Dropdown/Dropdown";
import StopWatch, { convertTimeToSeconds, convertTimeToMinutes } from "../StopWatch/StopWatch";

import "./LostAndFoundResults.scss";

interface IProps {
  result: any;
  onChange(result: RatRaceScoreDto): void;
}

const resultOptions: IOption[] = [
  { id: "None",                                    value: "None"                                    },
  { id: Constants.score_result_type.qualified,     value: Constants.score_result_type.qualified     },
  { id: Constants.score_result_type.not_qualified, value: Constants.score_result_type.not_qualified },
  { id: Constants.score_result_type.disqualified,  value: Constants.score_result_type.disqualified  },
  { id: Constants.score_result_type.excused,       value: Constants.score_result_type.excused       },
  { id: Constants.score_result_type.absent,        value: Constants.score_result_type.absent        },
];

const LostAndFoundResults: React.FC<IProps> = (props) => {
  const getOptionLabel = (id: string) =>
    resultOptions.find((o) => o.id === id)?.value ?? "None";

  const [result, setResult] = useState<IOption>({
    id: props.result.lost_and_found?.result_type ?? Constants.score_result_type.qualified,
    value: getOptionLabel(props.result.lost_and_found?.result_type ?? Constants.score_result_type.qualified),
  });
  const [time, setTime] = useState<string>(
    props.result.lost_and_found?.time
      ? convertTimeToMinutes(props.result.lost_and_found?.time.toString())
      : ""
  );
  const [faultCount, setFaultCount] = useState<string>(
    props.result.lost_and_found?.fault_count
      ? props.result.lost_and_found?.fault_count.toString()
      : "0"
  );

  const [hasChanged, setHasChanged] = useState<boolean>(false);

  const isQualified = result.id === Constants.score_result_type.qualified;

  useEffect(() => {
    if (hasChanged) {
      props.onChange({
        result_type: result.id,
        time: isQualified ? convertTimeToSeconds(time) : 0,
        fault_count: isQualified ? Number(faultCount) : 0,
        rats_found: 0,
      });
      setHasChanged(false);
    }
  }, [hasChanged, props, faultCount, time, result.id, isQualified]);

  return (
    <div className="LostAndFoundResults">
      <div className="row">
        <Dropdown
          value={result}
          onChange={(e: any, value: IOption) => {
            setResult(value);
            setHasChanged(true);
          }}
          label="Result"
          options={resultOptions}
          placeholder=""
        />
      </div>
      {isQualified && (
        <>
          <div className="row">
            <StopWatch
              time={time}
              onChange={(value: string) => {
                setTime(value);
                setHasChanged(true);
              }}
            />
          </div>
          <div className="row">
            <Input
              label="Fault Count"
              id="faultCount"
              type="number"
              min="0"
              required
              onChange={(e) => {
                e.stopPropagation();
                setFaultCount(e.target.value);
                setHasChanged(true);
              }}
              placeholder=""
              defaultValue={faultCount}
            />
          </div>
        </>
      )}
    </div>
  );
};

export default LostAndFoundResults;
